import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/material-design/css/material-icons.min.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import "react-day-picker/lib/style.css";
import { toast } from "react-toastify";
import { compose } from "redux";
import DayPicker from "react-day-picker";
import ontime from "../../assets/images/on-time.png";
import notime from "../../assets/images/no-time.png";

import {
  AdCard,
  singlefrequencyAssigner,
  scheduleIdentifier,
  AdSchedule,
  getidfromkey,
  getidfromkeystr,
  cartesian,
} from "../../functions/buyairtime";
import {
  GetTimeSlotsTest,
  GetDestinationsTest,
  GetCarModelsTest,
  GetRegionsForBusiness,
  GetAdSchedules,
  GetRouteAverages,
} from "../../store/actions/regionActions";
import { GetController } from "../../store/actions/adcardActions";
import { Select, Tag, Form, Input, Modal, Button, Typography } from "antd";
import { connect } from "react-redux";
import {
  signInAnonymously,
  deleteAnonUser,
} from "../../store/actions/authActions";
import {
  adbudgetValidation,
  adfrequencyValidation,
  adtitleValidation,
} from "../../functions/utils";
const { Option } = Select;
const { Title } = Typography;

class BusinessTestBuyComponent extends Component {
  constructor(props) {
    super(props);
    const date = new Date();
    const sdate = new Date();
    date.setDate(date.getDate() + 2);
    sdate.setDate(date.getDate() - 1);

    this.state = {
      check: false,
      loading: false,
      specifyRegion: false,
      selectedRegion: null,
      specifyDestination: false,
      specifyTimeslot: false,
      specifyVehicle: false,
      specifyEndDate: false,
      specifyStartDate: true,
      startDateLoading: false,
      showvideo: false,
      ad_title: "This is a Testing AD",
      calculated_price: 0,
      ad_length: 30,
      ad_length_low: false,
      calculated_length: 30,
      ad_playing_amount: 20,
      min_serving_amount: 20,
      max_serving_amount: 30,
      frequency_per_route: 2,
      budget: 300,
      startregionloading: false,
      estimated_frequency_per_day: 20,
      start_date: date,
      static_start_date: date,
      static_valid_date: sdate,
      end_date: "",
      time_slots: [],
      timeslots: [],
      vehicle_types: [],
      carmodels: [],
      destinations: [],
      dest_inations: [],
      minserveamount: "-",
      preserveamount: "-",
      maxserveamount: "-",
      time_calculated: true,
      selectedRegionObj: null,
      scheduledMap: new Map(),
      disabledstartingdays: [],
      routeAverages: [],
      adSchedules: [],
      adCard: null,
      onProgress: true,
      duration: 0,
      overThreeFourthOccupied: [],
      o_overThreeFourthOccupied: [],
      fullOccupied: [],
      o_fullOccupied: [],
      timeframes: [30],
      newAdschedules: [],
      adcardresult: null,
      formchange: false,
      adtitleError: "",
      fileError: "",
      budgetError: "",
      frequencyError: "",
      showform: false,
      areyousureModal: false,
      missingerror: "",
      askchangeregion: false,
      regionerror: false,
      majorerror: false,
      timestatus: 0,
      formchangesubmit: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.showVideo = this.showVideo.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  componentDidMount() {}

  // componentWillUnmount() {
  //   window.removeEventListener("beforeunload", (ev) => {});
  // }

  componentDidUpdate(prev, prevState) {
    try {
      if (this.props.auth.uid !== undefined && prev.auth.uid === undefined) {
        this.props.getRegions();
      } else if (!this.props.region.loading && prev.region.loading) {
        console.log("uiddd");
        window.addEventListener("beforeunload", (ev) => {
          ev.preventDefault();
          this.props.deleteAnonUser();
          return (ev.returnValue = "Are you sure you want to close?");
        });
        if (this.props.region.length === 0) {
          this.setState({
            regionerror: true,
          });
        } else {
          const date = new Date();
          const sdate = new Date();
          date.setDate(
            date.getDate() + this.props.region.regions[0].extraStartDays
          );
          sdate.setDate(
            date.getDate() - this.props.region.regions[0].extraStartDays - 1
          );
          console.log("REGION");
          console.log(this.props.region.regions[0]);
          const temptimeframes = [];
          for (
            let index = this.props.region.regions[0].adBrakeMaximumLength;
            index >= 1;
            index--
          ) {
            temptimeframes.push(30 * index);
          }

          this.setState({
            selectedRegion: this.props.region.regions[0].id,
            selectedRegionObj: this.props.region.regions[0],
            timeframes: temptimeframes,
            specifyRegion: true,
            showform: true,
            start_date: date,
            static_start_date: date,
            static_valid_date: sdate,
            budget: this.props.region.regions[0].minimumBudget,
          });
          this.props.getController(this.props.region.regions[0].id);
          this.props.getTimeSlots(this.props.region.regions[0].id);
          this.props.getDestinations(this.props.region.regions[0].id);
          this.props.getCarModels(this.props.region.regions[0].id);
          this.props.getRouteAverages(this.props.region.regions[0].id);
        }
      } else if (
        prev.region.timeslotsloading === true &&
        this.props.region.timeslotsloading === false
      ) {
        const ts = [];
        this.props.region.timeslots.forEach((t) => {
          const timeobj = {
            startTime: "",
            endTime: "",
          };
          var tmp = "";
          tmp = t.startTime.toDate().getHours();
          if (tmp >= 12) {
            timeobj.startTime =
              (t.startTime.toDate().getHours() - 12).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              ":" +
              t.startTime.toDate().getMinutes().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              " pm";
          } else {
            timeobj.startTime =
              t.startTime.toDate().getHours().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              ":" +
              t.startTime.toDate().getMinutes().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              " am";
          }
          tmp = "";
          tmp = t.endTime.toDate().getHours();
          if (tmp >= 12) {
            timeobj.endTime =
              (t.endTime.toDate().getHours() - 12).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              ":" +
              t.endTime.toDate().getMinutes().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              " pm";
          } else {
            timeobj.endTime =
              t.endTime.toDate().getHours().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              ":" +
              t.endTime.toDate().getMinutes().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              }) +
              " am";
          }

          ts.push(
            <Option
              key={
                timeobj.startTime + " - " + timeobj.endTime + " :::: " + t.id
              }
            >
              {timeobj.startTime + " - " + timeobj.endTime}
            </Option>
          );
        });
        if (ts.length === 0) {
          this.setState({
            askchangeregion: true,
          });
        } else {
          this.setState({
            timeslots: ts,
          });
        }
      } else if (
        prev.region.carmodelsloading === true &&
        this.props.region.carmodelsloading === false
      ) {
        const cms = [];
        this.props.region.carmodels.forEach((cm) => {
          cms.push(<Option key={cm.name + " :::: " + cm.id}>{cm.name}</Option>);
        });
        if (cms.length === 0) {
          this.setState({
            askchangeregion: true,
            missingerror: "No Car Models",
          });
        } else {
          this.setState({
            carmodels: cms,
          });
        }
      } else if (
        prev.region.destinationsloading === true &&
        this.props.region.destinationsloading === false
      ) {
        const dss = [];
        this.props.region.destinations.forEach((cm) => {
          dss.push(
            <Option key={cm.destination + " :::: " + cm.id}>
              {cm.destination}
            </Option>
          );
        });
        if (dss.length === 0) {
          this.setState({
            askchangeregion: true,
            missingerror: "No AD Destinations",
          });
        } else {
          this.setState({
            destinations: dss,
          });
        }
      } else if (
        prev.region.adscheduleloading === true &&
        this.props.region.adscheduleloading === false
      ) {
        if (this.props.region.adschedules.size > 0) {
          const disabledstartingds = [];
          const threefourthstartingds = [];
          this.props.region.adschedules.forEach((value, key) => {
            if (value.totalaastd === value.totalspot) {
              disabledstartingds.push(new Date(Date.parse(key)));
            } else if ((value.totalaastd * 100) / value.totalspot > 75) {
              threefourthstartingds.push(new Date(Date.parse(key)));
            }
          });

          this.setState({
            o_overThreeFourthOccupied: threefourthstartingds,
            o_fullOccupied: disabledstartingds,
          });
          //   const schMap = this.state.scheduledMap;
          //   const schs = [];
          //   const disabledstartingds = [];
          //   const threefourthstartingds = [];
          //   var tempschedules = {};
          //   this.props.region.adschedules.forEach((sche) => {
          //     tempschedules = { ...sche.adSchedules, ...tempschedules };
          //   });
          //   //console.log(tempschedules)

          //   var i = 0;
          //   while (true) {
          //     const sch = tempschedules[i];
          //     if (sch === undefined) {
          //       break;
          //     } else {
          //       const datestring = sch.date.toDate().toDateString();
          //       const obj = { ...sch, total: sch.aalst + sch.aastd };
          //       schs.push(
          //         new AdSchedule(
          //           new Date(Date.parse(datestring)),
          //           sch.cm,
          //           sch.ts,
          //           sch.sp,
          //           sch.aastd,
          //           sch.aalst
          //         )
          //       );
          //       if (schMap.has(datestring)) {
          //         const temp = schMap.get(datestring);
          //         temp.totalspot += obj.total;
          //         temp.totalaastd += obj.aastd;
          //         temp.combs.push(obj);
          //         schMap.set(datestring, temp);
          //       } else {
          //         schMap.set(datestring, {
          //           combs: [obj],
          //           totalspot: obj.total,
          //           totalaastd: obj.aastd,
          //         });
          //       }
          //     }
          //     i++;
          //   }

          //   schMap.forEach((value, key) => {
          //     if (value.totalaastd === value.totalspot) {
          //       disabledstartingds.push(new Date(Date.parse(key)));
          //     } else if ((value.totalaastd * 100) / value.totalspot > 75) {
          //       threefourthstartingds.push(new Date(Date.parse(key)));
          //     }
          //   });
          //   if (this.state.adSchedules.length === 0) {
          //     this.setState({
          //       scheduledMap: schMap,
          //       disabledstartingdays: disabledstartingds,
          //       threefourthstartingdays: threefourthstartingds,
          //       adSchedules: schs,
          //     });
          //   }

          //   schs.forEach((s) => {
          //     staticadschedules.push(s);
          //   });

          //   console.log("FIRST SCHS");
          //   console.log(hash(staticadschedules));

          //   const programs = [];
          //   const fullprograms = [];

          //   schs.forEach((adsch) => {
          //     if ((adsch.aastd * 100) / (adsch.aastd + adsch.aalst) === 100) {
          //       fullprograms.push(adsch.date);
          //     } else if (
          //       (adsch.aastd * 100) / (adsch.aastd + adsch.aalst) >=
          //       75
          //     ) {
          //       programs.push(adsch.date);
          //     }
          //   });
          //   console.log("PROGRAMS");
          //   console.log(programs.length);
          //   this.setState({
          //     overThreeFourthOccupied: programs,
          //     fullOccupied: fullprograms,
          //   });
        }
      } else if (
        prev.region.routeaverageloading === true &&
        this.props.region.routeaverageloading === false
      ) {
        if (this.props.region.routeaverages.size === 0) {
          this.setState({
            askchangeregion: true,
            missingerror: "No Route Averages",
          });
        } else {
          if (this.state.selectedRegionObj === null) {
            this.props.getAdSchedules(
              this.props.region.regions[0].id,
              this.props.region.regions[0].extraStartDays,
              this.props.region.regions[0].roughEstimate
            );
          } else {
            this.props.getAdSchedules(
              this.state.selectedRegion,
              this.state.selectedRegionObj.extraStartDays,
              this.state.selectedRegionObj.roughEstimate
            );
          }
          // const pureRouteAverages = [];
          // this.props.region.routeaverages.forEach((ra) => {
          //   pureRouteAverages.push(
          //     new RouteAverage(
          //       ra.cm,
          //       ra.ts,
          //       ra.sp,
          //       ra.totalAmountOfRoute,
          //       ra.averageAdBrake,
          //       ra.rfstpd,
          //       ra.scstpd,
          //       ra.scstppd
          //     )
          //   );
          // });
          // this.setState({
          //   routeAverages: pureRouteAverages,
          // });
        }
      } else if (
        prevState.showloadingwhilecalculating !==
        this.state.showloadingwhilecalculating
      ) {
        if (this.state.showloadingwhilecalculating) {
          this.setState({
            onProgress: true,
          });
          setTimeout(
            function () {
              //Start the timer
              this.calculateServingAmount();
            }.bind(this),
            100
          );
        }
      }
    } catch (e) {
      toast.error("Please Refresh the Page");
      console.log(e);
    }
  }

  onClear() {
    const date = new Date();
    date.setDate(date.getDate() + 2);
    this.setState({
      specifyDestination: false,
      specifyTimeslot: false,
      specifyVehicle: false,
      specifyEndDate: false,
      specifyStartDate: true,
      startDateLoading: false,
      showvideo: false,
      ad_title: "This is a Testing AD",
      calculated_price: 0,
      ad_length_low: false,
      time_calculated: true,
      ad_length: 30,
      calculated_length: 30,
      ad_playing_amount: 20,
      min_serving_amount: 20,
      max_serving_amount: 30,
      frequency_per_route: 2,
      overThreeFourthOccupied: this.state.o_overThreeFourthOccupied,
      fullOccupied: this.state.o_fullOccupied,
      // o_overThreeFourthOccupied: [],
      // o_fullOccupied: [],
      budget:
        this.state.selectedRegionObj.minimumBudget !== undefined &&
        this.state.selectedRegionObj.minimumBudget !== null
          ? this.state.selectedRegionObj.minimumBudget
          : 300,
      estimated_frequency_per_day: 20,
      start_date: date,
      end_date: "",
      time_slots: [],
      vehicle_types: [],
      dest_inations: [],
      areyousureModal: false,
      majorerror: false,
      onProgress: true,
      timestatus: 0,
      formchangesubmit: false,
    });
  }

  handleOk = () => {
    this.setState({ submittest: false });
    this.props.deleteAnonUser();
    window.location = "/business_register";
  };

  handleCancel = () => {
    this.props.deleteAnonUser();
    this.setState({ submittest: false, formchangesubmit: false });
  };

  onFinish = () => {};

  onFinishFailed = (errorInfo) => {
    toast.error(errorInfo);
  };

  showVideo() {
    this.setState({
      showvideo: !this.state.showvideo,
    });
  }

  showModal = () => {
    this.setState({
      areyousureModal: true,
    });
  };

  showFormChangeError = () => {
    this.setState({
      formchangesubmit: true,
    });
  };

  handleOkSure = () => {
    this.setState({
      showform: false,
      areyousureModal: false,
      formchangesubmit: false,
    });
  };

  handleCancelSure = () => {
    this.props.deleteAnonUser();
    this.setState({
      areyousureModal: false,
      formchangesubmit: false,
    });
  };

  onSpecifyStartDate() {
    try {
      let cm = [];
      let ts = [];
      let sp = [];

      if (this.state.vehicle_types.length === 0) {
        this.state.carmodels.forEach((c) => {
          cm.push(getidfromkeystr(c.key));
        });
      } else {
        cm = this.state.vehicle_types;
      }

      if (this.state.time_slots.length === 0) {
        this.state.timeslots.forEach((t) => {
          ts.push(getidfromkeystr(t.key));
        });
      } else {
        ts = this.state.time_slots;
      }

      if (this.state.dest_inations.length === 0) {
        this.state.destinations.forEach((s) => {
          sp.push(getidfromkeystr(s.key));
        });
      } else {
        sp = this.state.dest_inations;
      }
      const combinations = cartesian(sp, ts, cm);
      const disabledstartingds = [];
      const threefourthstartingds = [];
      //var printed = false;
      this.props.region.adschedules.forEach((values, key) => {
        var ttotal = 0;
        var toccupied = 0;
        //console.log("-----");
        combinations.forEach((cart) => {
          try {
            // if (!printed) {
            //   console.log(cart[0] + "___" + cart[1] + "___" + cart[2]);
            //   console.log(
            //     values.combs.get(cart[0] + "___" + cart[1] + "___" + cart[2])
            //       .aalst
            //   );
            //   console.log(
            //     values.combs.get(cart[0] + "___" + cart[1] + "___" + cart[2])
            //       .aastd
            //   );
            // }
            toccupied += values.combs.get(
              cart[0] + "___" + cart[1] + "___" + cart[2]
            ).aastd;
            ttotal +=
              values.combs.get(cart[0] + "___" + cart[1] + "___" + cart[2])
                .aastd +
              values.combs.get(cart[0] + "___" + cart[1] + "___" + cart[2])
                .aalst;
          } catch (e) {
            toast.error("Error on Matching Days with ADSCH");
            console.log("ERRROR ON SPECIFY DATE");
            console.log(e);
          }
        });

        if (ttotal === toccupied) {
          disabledstartingds.push(new Date(Date.parse(key)));
        } else if ((toccupied * 100) / ttotal > 75) {
          // if (!printed) {
          //   console.log(key);
          //   console.log(toccupied);
          //   console.log(ttotal);
          //   printed = true;
          // }
          threefourthstartingds.push(new Date(Date.parse(key)));
        }
      });

      this.setState({
        overThreeFourthOccupied: threefourthstartingds,
        fullOccupied: disabledstartingds,
        specifyStartDate: true,
        startDateLoading: false,
      });
    } catch (e) {
      this.setState({
        overThreeFourthOccupied: this.state.o_overThreeFourthOccupied,
        fullOccupied: this.state.o_fullOccupied,
        specifyStartDate: true,
        startDateLoading: false,
      });
      toast.error("Error on Date Match");
      console.log("ERRROR ON SPECIFY DATE");
      console.log(e);
    }
  }

  calculateServingAmount() {
    try {
      this.setState({
        onProgress: true,
      });
      if (this.state.selectedRegionObj !== null) {
        let cm = [];
        let ts = [];
        let sp = [];

        if (this.state.vehicle_types.length === 0) {
          this.state.carmodels.forEach((c) => {
            cm.push(getidfromkeystr(c.key));
          });
        } else {
          cm = this.state.vehicle_types;
        }

        if (this.state.time_slots.length === 0) {
          this.state.timeslots.forEach((t) => {
            ts.push(getidfromkeystr(t.key));
          });
        } else {
          ts = this.state.time_slots;
        }

        if (this.state.dest_inations.length === 0) {
          this.state.destinations.forEach((s) => {
            sp.push(getidfromkeystr(s.key));
          });
        } else {
          sp = this.state.dest_inations;
        }

        var found = false;
        for (
          let index = 0;
          index < Array.from(this.props.region.routeaverages.keys()).length;
          index++
        ) {
          const ra = Array.from(this.props.region.routeaverages.keys())[index];
          if (
            sp.includes(this.props.region.routeaverages.get(ra).sp) &&
            ts.includes(this.props.region.routeaverages.get(ra).ts) &&
            cm.includes(this.props.region.routeaverages.get(ra).cm)
          ) {
            found = true;
            break;
          }
        }
        if (found) {
          const card = new AdCard(
            this.state.ad_title,
            parseFloat(this.state.calculated_length) / 30,
            parseInt(this.state.frequency_per_route),
            cm,
            ts,
            sp,
            parseFloat(this.state.budget),
            new Date(),
            this.state.start_date,
            this.state.end_date === "" || this.state.end_date === null
              ? new Date(
                  new Date().setDate(
                    this.state.start_date.getDate() +
                      this.state.selectedRegionObj.roughEstimate -
                      1
                  )
                )
              : this.state.end_date
          );
          let valueMap = new Map();
          this.props.region.carmodels.forEach((car) => {
            valueMap.set(car.id + "c", car.percentage);
          });
          this.props.region.timeslots.forEach((time) => {
            valueMap.set(time.id + "t", time.percentage);
          });
          // this.props.region.timeslots.forEach((time) => {
          //   console.log(time);
          //   valueMap.set(time.id + "t", time.percentage);
          // });

          this.props.region.destinations.forEach((ds) => {
            valueMap.set(ds.id + "s", ds.price);
          });

          let newAdCard = singlefrequencyAssigner(valueMap, card);
          this.setState({
            adCard: newAdCard,
          });
          console.log("New Ad card");
          console.log(newAdCard);

          let min = Number.MAX_VALUE;
          let max = 0;
          newAdCard.list_of_frequency.forEach((value, key) => {
            if (value[0] < min) {
              min = value[0];
            }
            if (value[0] > max) {
              max = value[0];
            }
          });
          // console.log("New Adddd");
          // console.log(newAdCard);
          //console.log(valueMap);

          // console.log(staticadschedules);

          const tempadsch = [];

          var i = 0;
          while (true) {
            const obj = this.props.region.scheduleslist[i];
            if (obj === undefined) {
              break;
            } else {
              tempadsch.push(
                new AdSchedule(
                  new Date(obj.date.toDate().setHours(0, 0, 0)),
                  obj.cm,
                  obj.ts,
                  obj.sp,
                  obj.aastd,
                  obj.aalst
                )
              );
            }
            i++;
          }

          const identified = scheduleIdentifier(
            Array.from(this.props.region.routeaverages.values()),
            tempadsch,
            newAdCard,
            this.state.static_start_date,
            this.state.selectedRegionObj.adBrakeMaximumLength
          );

          console.log("TASCPD");
          console.log(identified[2].tascpd);

          //console.log(identified);
          var predicted = 0;
          identified[2].tascpd.forEach((td) => {
            predicted += td.value;
          });
          predicted = parseInt(predicted / (this.state.calculated_length / 30));

          console.log("static_start_date");
          console.log(this.state.static_start_date);

          // const programs = [];
          // const fullprograms = [];

          // this.state.adSchedules.forEach((rj) => {
          //   if ((rj.aastd * 100) / (rj.aastd + rj.aalst) >= 99) {
          //     fullprograms.push(rj.date);
          //   } else if ((rj.aastd * 100) / (rj.aastd + rj.aalst) >= 75) {
          //     programs.push(rj.date);
          //   }
          // });

          // if (identified[0] >= this.state.selectedRegionObj.roughEstimate) {
          //   toast.warning(
          //     "Please read the Disclamer under the results of the prediction and Expire Date"
          //   );
          // }
          //console.log("Occupied");
          //console.log(programs);

          const date = new Date();
          date.setDate(
            date.getDate() + this.state.selectedRegionObj.extraStartDays
          );

          var endingdate = new Date(identified[2].end_date);

          this.state.selectedRegionObj !== null &&
          endingdate >
            new Date(
              new Date().setDate(
                date.getDate() + this.state.selectedRegionObj.roughEstimate - 1
              )
            )
            ? (endingdate = new Date(
                new Date().setDate(
                  date.getDate() +
                    this.state.selectedRegionObj.roughEstimate -
                    1
                )
              ))
            : console.log("-");

          var dd = 0;
          dd = identified[0];
          if (
            this.props.adcard.controller !== null &&
            this.props.adcard.controller !== undefined
          ) {
            if (
              ((this.props.adcard.controller.asipDate !== undefined) !==
                this.props.adcard.controller.asipDate) !==
              null
            ) {
              try {
                const asipdatee = this.props.adcard.controller.asipDate
                  .toDate()
                  .setHours(0, 0, 0, 0);

                const margin = Math.ceil(
                  (new Date().setHours(0, 0, 0, 0) - asipdatee) /
                    (1000 * 60 * 60 * 24)
                );

                console.log("Margin");
                console.log(margin);

                if (margin > 0) {
                  dd += margin;
                }
              } catch (e) {
                console.log(e);
              }
            }
          }

          this.state.selectedRegionObj !== null &&
          dd >=
            Math.ceil(
              (identified[2].end_date - identified[2].start_date) /
                (1000 * 60 * 60 * 24)
            ) +
              1
            ? this.setState({
                timestatus: 2,
              })
            : this.state.selectedRegionObj !== null &&
              dd >= this.state.selectedRegionObj.roughEstimate
            ? this.setState({
                timestatus: 2,
              })
            : this.setState({
                timestatus: 1,
              });

          this.setState({
            formchange: false,
            adcardresult: identified[2],
            minserveamount: min,
            preserveamount: predicted,
            maxserveamount: max,
            ad_static_start_date: new Date(identified[2].start_date),
            ad_start_date: new Date(identified[2].start_date),
            onProgress: false,
            duration: dd,
            newAdschedules: identified[1],
            end_date: endingdate,
            showloadingwhilecalculating: false,
          });
          console.log("static_start_date");
          console.log(identified[2].start_date);
        } else {
          toast.error(
            "Sorry we couldn't process your inputs. Please change your inputs to a more general selections or try again later.",
            { autoClose: 4000 }
          );
          this.setState({
            showloadingwhilecalculating: false,
          });
        }
      }
    } catch (e) {
      console.log("ERRORR----");
      console.log(e);
      this.setState({
        showloadingwhilecalculating: false,
      });
      toast.error("Couldn't Calculate Serving Amount, Please Try Again", {
        autoClose: 2000,
      });
    }
  }

  handleFormChange(event) {
    switch (event.target.id) {
      case "namefield":
        this.setState({
          ad_title: event.target.value,
        });
        break;
      case "regionfield":
        const regionarray = this.props.region.regions.filter(function (e) {
          return e.id === event.target.value;
        });
        const newregion = regionarray.length > 0 ? regionarray[0] : null;

        if (newregion !== null) {
          const date = new Date();
          const sdate = new Date();
          date.setDate(date.getDate() + newregion.extraStartDays);
          sdate.setDate(date.getDate() - newregion.extraStartDays - 1);
          const temptimeframes = [];
          for (
            let index = newregion.adBrakeMaximumLength;
            index >= 1;
            index--
          ) {
            temptimeframes.push(30 * index);
          }
          this.setState({
            showform: true,
            start_date: date,
            static_start_date: date,
            static_valid_date: sdate,
            selectedRegion: event.target.value,
            selectedRegionObj: newregion,
            specifyRegion: true,
            askchangeregion: false,
            timeframes: temptimeframes,
            missingerror: "",
            onProgress: true,
            specifyDestination: false,
            specifyTimeslot: false,
            specifyVehicle: false,
            specifyEndDate: false,
            specifyStartDate: true,
            startDateLoading: false,
            showvideo: false,
            calculated_price: 0,
            calculated_length: 30,
            ad_length: 30,
            ad_length_low: false,
            time_calculated: true,
            ad_playing_amount: 20,
            min_serving_amount: 20,
            max_serving_amount: 30,
            frequency_per_route: 1,
            estimated_frequency_per_day: 20,
            end_date: "",
            time_slots: [],
            vehicle_types: [],
            dest_inations: [],
            areyousureModal: false,
            majorerror: false,
            o_overThreeFourthOccupied: this.state.overThreeFourthOccupied,
            o_fullOccupied: this.state.o_fullOccupied,
            overThreeFourthOccupied: [],
            fullOccupied: [],
            budget: this.state.minimumBudget,
          });
          this.props.getController(event.target.value);
          this.props.getTimeSlots(event.target.value);
          this.props.getDestinations(event.target.value);
          this.props.getCarModels(event.target.value);
          this.props.getRouteAverages(event.target.value);
        } else {
          toast.error("Please Refresh the Page");
        }
        break;
      default:
        break;
    }
  }

  handleUnSpecifyChange(event) {
    switch (event) {
      case "specifyDestination":
        if (
          this.state.time_slots.length === 0 &&
          this.state.vehicle_types.length === 0
        ) {
          this.setState({
            dest_inations: [],
            formchange: true,
            specifyStartDate: true,
            specifyDestination: !this.state.specifyDestination,
          });
        } else {
          this.setState({
            dest_inations: [],
            formchange: true,
            specifyStartDate: false,
            specifyDestination: !this.state.specifyDestination,
          });
        }
        break;
      case "specifyTimeslot":
        if (
          this.state.vehicle_types.length === 0 &&
          this.state.dest_inations.length === 0
        ) {
          this.setState({
            time_slots: [],
            formchange: true,
            specifyStartDate: true,
            specifyTimeslot: !this.state.specifyTimeslot,
          });
        } else {
          this.setState({
            time_slots: [],
            formchange: true,
            specifyStartDate: false,
            specifyTimeslot: !this.state.specifyTimeslot,
          });
        }
        break;
      case "specifyVehicle":
        if (
          this.state.time_slots.length === 0 &&
          this.state.dest_inations.length === 0
        ) {
          this.setState({
            vehicle_types: [],
            formchange: true,
            specifyStartDate: true,
            specifyVehicle: !this.state.specifyVehicle,
          });
        } else {
          this.setState({
            vehicle_types: [],
            formchange: true,
            specifyStartDate: false,
            specifyVehicle: !this.state.specifyVehicle,
          });
        }
        break;

      default:
        break;
    }
  }

  handleChange(event) {
    switch (event) {
      case "specifyDestination":
        this.setState({
          formchange: true,
        });
        if (this.state.specifyDestination) {
          this.setState({
            specifyStartDate: true,
          });
        }
        this.setState({
          specifyDestination: !this.state.specifyDestination,
        });
        break;
      case "specifyTimeslot":
        this.setState({
          formchange: true,
        });
        if (this.state.specifyTimeslot) {
          this.setState({
            specifyStartDate: true,
          });
        }
        this.setState({
          specifyTimeslot: !this.state.specifyTimeslot,
        });
        break;
      case "specifyVehicle":
        this.setState({
          formchange: true,
        });
        if (this.state.specifyVehicle) {
          this.setState({
            specifyStartDate: true,
          });
        }
        this.setState({
          specifyVehicle: !this.state.specifyVehicle,
        });
        break;
      case "specifyEndDate":
        this.setState({
          specifyEndDate: !this.state.specifyEndDate,
        });
        this.setState({
          specifyEndDate: !this.state.specifyEndDate,
        });
        break;

      default:
        break;
    }
  }

  modifiersStyles = {
    risky: {
      color: "#ffc107",
      backgroundColor: "#fffdf7",
    },
    done: {
      color: "#ff0000",
      backgroundColor: "#fff9f9",
    },
  };

  tagRender(props) {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  }

  render() {
    if (!this.state.showform) {
      return (
        <section className="info1 cid-smItKwpDu1 testsection" id="info1-5">
          <div className="align-center container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                {(this.props.auth.isEmpty && !this.props.auth.isLoaded) ||
                this.props.region.loading ? (
                  <div
                    className="row justify-content-center"
                    style={{ marginBottom: 40 }}
                  >
                    <h2 className="mbr-section-title mb-4 mbr-fonts-style align-center display-2">
                      {" "}
                      <br />
                      <br />
                      <strong>Loading</strong>
                      <br />
                      <div className="lds-ellipsis lds-ellipsis-white">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </h2>
                  </div>
                ) : !this.state.regionerror ? (
                  <div>
                    <h3 className="mbr-section-title mb-4 mbr-fonts-style display-2">
                      <strong>Check How Easy It Is !</strong>
                      <br />
                    </h3>

                    <h3 className="mbr-section-title mb-4 mbr-fonts-style display-5">
                      Try the mock-up version on how to buy airtime on Negarit,
                      see for youself, the dynamic nature of doing business with
                      us.
                      <br />
                    </h3>
                    {!this.state.check && (
                      <div className="mbr-section-btn">
                        <button
                          className="btn btn-white display-4"
                          onClick={() => {
                            this.setState({
                              check: true,
                            });
                            if (this.props.auth.uid) {
                              this.props.getRegions();
                              this.setState({
                                startregionloading: true,
                              });
                            } else {
                              this.props.signInAnonymously();
                            }
                          }}
                        >
                          Check How It Works
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="col-lg-12">
                    <div
                      className="row justify-content-center"
                      style={{ marginBottom: 40 }}
                    >
                      <h2 className="align-center display-2">
                        Testing is not Available, Please Try Again
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return (
        <div>
          <section className="form5 cid-ssQVVQ31b6" id="buyairtimeform">
            <div className="container-fluid">
              <div className="mbr-section-head">
                <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                  <strong>Test How Easy It Is To Buy Airtime</strong>
                  <br />
                </h3>
              </div>

              <div className="row justify-content-center mt-4">
                <div
                  className="col-lg-10 mx-auto mbr-form"
                  data-form-type="formoid"
                >
                  <div className="align-center mbr-section-btn">
                    <button
                      type="button"
                      onClick={() => {
                        this.showVideo();
                      }}
                      className="btn btn-success align-center display-4"
                    >
                      <span className="material material-remove-red-eye mbr-iconfont mbr-iconfont-btn"></span>
                      Watch How To Run the Test
                    </button>
                    {this.state.showvideo && (
                      <div className="video-container container">
                        <iframe
                          title="Watch How To Buy AirTime"
                          src="https://www.youtube.com/embed/02vYGXkhxyQ"
                          frameborder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </div>
                    )}
                  </div>
                  <div className="row justify-content-center mt-4">
                    <div
                      className="col-lg-8 mx-auto mbr-form"
                      data-form-type="formoid"
                    >
                      <Form
                        className="mbr-form form-with-styler"
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                      >
                        <div className="dragArea row">
                          <div className="col-2"></div>
                          <div
                            className="col-lg-8 form-group regionfield"
                            data-for="region"
                          >
                            <label
                              for="regionfield"
                              className="form-control-label mbr-fonts-style display-7"
                            >
                              Select Region *
                            </label>
                            <select
                              id="regionfield"
                              name="region"
                              disabled={
                                this.props.region.adscheduleloading ||
                                this.props.region.destinationsloading ||
                                this.props.region.timeslotsloading ||
                                this.props.region.carmodelsloading ||
                                this.props.region.routeaverageloading
                              }
                              className="form-control display-7"
                              value={this.state.selectedRegion}
                              onChange={this.handleFormChange}
                              required
                            >
                              {this.props.region.regions.map((reg) => (
                                <option value={reg.id}>{reg.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-2"></div>

                          {!this.state.askchangeregion &&
                          !this.props.region.destinationsloading &&
                          !this.props.region.timeslotsloading &&
                          !this.props.region.carmodelsloading &&
                          !this.props.region.adscheduleloading &&
                          !this.props.region.routeaverageloading ? (
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-lg-8 form-group">
                                    <label
                                      for="titlefield"
                                      className="form-control-label mbr-fonts-style display-7"
                                    >
                                      AD Title*
                                    </label>
                                    <input
                                      type="text"
                                      name="title"
                                      placeholder="Eg: This is a Testing AD"
                                      required
                                      maxLength="50"
                                      minLength="5"
                                      data-form-field="title"
                                      className="form-control"
                                      onChange={(val) => {
                                        this.setState({
                                          ad_title: val.target.value,
                                          formchange: true,
                                        });
                                        if (this.state.adtitleError !== "") {
                                          const tempadtitleError =
                                            adtitleValidation(val.target.value);
                                          this.setState({
                                            adtitleError: tempadtitleError,
                                          });
                                        }
                                      }}
                                      value={this.state.ad_title}
                                      id="titlefield"
                                    />
                                    <small className="errorHint">
                                      <i className="formerror fa fa-asterisk"></i>
                                      <p className="errorRed">
                                        {this.state.adtitleError}
                                      </p>
                                    </small>
                                  </div>
                                  <div className="col-lg-4 form-group">
                                    <label
                                      for="lengthfield"
                                      className="form-control-label mbr-fonts-style display-7"
                                    >
                                      AD Length*
                                    </label>
                                    <div className="row">
                                      <div className="col-6">
                                        <input
                                          type="number"
                                          maxLength="3"
                                          max={
                                            this.state.timeframes.length > 0
                                              ? this.state.timeframes[0]
                                              : 30
                                          }
                                          min="0"
                                          name="length"
                                          required
                                          data-form-field="length"
                                          className="form-control"
                                          onChange={(val) => {
                                            try {
                                              this.setState({
                                                ad_length_low: false,
                                                ad_length: val.target.value,
                                              });
                                              if (
                                                parseInt(val.target.value) > 0
                                              ) {
                                                this.setState({
                                                  ad_length_low: false,
                                                  ad_length: parseInt(
                                                    val.target.value
                                                  ),
                                                });
                                                var roof = 0;
                                                this.state.timeframes.forEach(
                                                  (tf) => {
                                                    if (
                                                      parseInt(
                                                        val.target.value
                                                      ) <= tf
                                                    ) {
                                                      roof = tf;
                                                    }
                                                  }
                                                );
                                                this.setState({
                                                  formchange: true,
                                                  calculated_length: roof,
                                                  time_calculated: true,
                                                });
                                              } else {
                                                this.setState({
                                                  ad_length_low: true,
                                                  calculated_length: 0,
                                                  time_calculated: false,
                                                });
                                              }
                                            } catch (e) {
                                              toast.error(
                                                "Please, Enter a Proper Value"
                                              );
                                            }
                                          }}
                                          value={this.state.ad_length}
                                          id="lengthfield"
                                          oninput="amount.value=lengthfield.value"
                                        />
                                        {this.state.ad_length_low && (
                                          <p
                                            className="mbr-section-title mbr-fonts-style align-left mb-0 display-9"
                                            style={{ color: "red" }}
                                          >
                                            30 Seconds is the Minimum Length
                                          </p>
                                        )}
                                      </div>
                                      <div className="col-6">
                                        <h3
                                          className="mbr-section-title mbr-fonts-style align-left mb-0 display-7"
                                          style={{ textAlign: "left" }}
                                        >
                                          <strong>Seconds</strong>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="col-lg-12 form-group calculatedlength"
                                    style={{
                                      display: this.state.time_calculated
                                        ? "block"
                                        : "none",
                                    }}
                                  >
                                    <label
                                      for="amount"
                                      className="form-control-label mbr-fonts-style display-7"
                                    >
                                      Calculated Length Category
                                    </label>
                                    {this.state.calculated_length !== 0 ? (
                                      <h3 className="mbr-section-title mbr-fonts-style align-left mb-0 display-5">
                                        <span
                                          id="amount"
                                          name="amount"
                                          for="lengthfield"
                                        >
                                          <strong>
                                            {this.state.calculated_length}
                                          </strong>
                                        </span>
                                        &nbsp; Seconds
                                      </h3>
                                    ) : (
                                      <h3
                                        className="mbr-section-title mbr-fonts-style align-left mb-0 display-7"
                                        style={{ color: "red" }}
                                      >
                                        Audio Length Shouldn't be greater than{" "}
                                        <strong>
                                          {this.state.timeframes[0].toString()}
                                        </strong>
                                        &nbsp;Seconds, Select a shorter Length
                                        File
                                      </h3>
                                    )}
                                  </div>
                                  <div className="col-lg-12">
                                    <div
                                      className="row"
                                      style={{ marginBottom: 40 }}
                                    >
                                      <div className="col-lg-4">
                                        <div
                                          className="row"
                                          style={{ marginBottom: 40 }}
                                        >
                                          <div className="col-12">
                                            <button
                                              type="button"
                                              onClick={() => {
                                                this.state.specifyDestination
                                                  ? this.handleUnSpecifyChange(
                                                      "specifyDestination"
                                                    )
                                                  : this.handleChange(
                                                      "specifyDestination"
                                                    );
                                              }}
                                              className={
                                                this.state.specifyDestination
                                                  ? "btn btn-black display-4 specifybutton"
                                                  : "btn btn-success display-4 specifybutton"
                                              }
                                            >
                                              {this.state.specifyDestination ? (
                                                <span>
                                                  Select
                                                  <br />
                                                  All Destinations
                                                </span>
                                              ) : (
                                                <span>
                                                  Specify
                                                  <br />
                                                  Destinations
                                                </span>
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                        {this.state.specifyDestination &&
                                          this.state.destinations.length >
                                            0 && (
                                            <div className="col-lg-12 form-group destinationfield">
                                              <label
                                                for="destinationfield"
                                                className="form-control-label mbr-fonts-style display-7"
                                              >
                                                Select Destinations
                                              </label>

                                              <Select
                                                mode="multiple"
                                                showArrow
                                                tagRender={this.tagRender}
                                                style={{ width: "100%" }}
                                                onChange={(selectedvalue) => {
                                                  if (
                                                    selectedvalue.length > 0
                                                  ) {
                                                    this.setState({
                                                      dest_inations:
                                                        getidfromkey(
                                                          selectedvalue
                                                        ),
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                  // else if (
                                                  //   this.state.time_slots
                                                  //     .length === 0 &&
                                                  //   this.state.vehicle_types
                                                  //     .length === 0
                                                  // ) {
                                                  //   this.setState({
                                                  //     dest_inations: [],
                                                  //     formchange: true,
                                                  //     specifyStartDate: true,
                                                  //   });
                                                  // }
                                                  else {
                                                    this.setState({
                                                      dest_inations: [],
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                }}
                                              >
                                                {this.state.destinations}
                                              </Select>
                                            </div>
                                          )}
                                      </div>
                                      <div className="col-lg-4">
                                        <div
                                          className="row"
                                          style={{ marginBottom: 40 }}
                                        >
                                          <div className="col-12">
                                            <button
                                              type="button"
                                              onClick={() => {
                                                this.state.specifyTimeslot
                                                  ? this.handleUnSpecifyChange(
                                                      "specifyTimeslot"
                                                    )
                                                  : this.handleChange(
                                                      "specifyTimeslot"
                                                    );
                                              }}
                                              className={
                                                this.state.specifyTimeslot
                                                  ? "btn btn-black display-4 specifybutton"
                                                  : "btn btn-success display-4 specifybutton"
                                              }
                                            >
                                              {this.state.specifyTimeslot ? (
                                                <span>
                                                  Select
                                                  <br />
                                                  All Timeslots
                                                </span>
                                              ) : (
                                                <span>
                                                  Specify
                                                  <br />
                                                  Timeslots
                                                </span>
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                        {this.state.specifyTimeslot &&
                                          this.state.timeslots.length > 0 && (
                                            <div className="col-lg-12 form-group timeslotfield">
                                              <label
                                                for="timeslotfield"
                                                className="form-control-label mbr-fonts-style display-7"
                                              >
                                                Select Timeslots
                                              </label>
                                              <Select
                                                onChange={(selectedvalue) => {
                                                  if (
                                                    selectedvalue.length > 0
                                                  ) {
                                                    this.setState({
                                                      time_slots:
                                                        getidfromkey(
                                                          selectedvalue
                                                        ),
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                  // else if (
                                                  //   this.state.dest_inations
                                                  //     .length === 0 &&
                                                  //   this.state.vehicle_types
                                                  //     .length === 0
                                                  // ) {
                                                  //   this.setState({
                                                  //     time_slots: [],
                                                  //     formchange: true,
                                                  //     specifyStartDate: true,
                                                  //   });
                                                  // }
                                                  else {
                                                    this.setState({
                                                      time_slots: [],
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                }}
                                                mode="multiple"
                                                showArrow
                                                tagRender={this.tagRender}
                                                style={{ width: "100%" }}
                                              >
                                                {this.state.timeslots}
                                              </Select>
                                            </div>
                                          )}
                                      </div>
                                      <div className="col-lg-4">
                                        <div
                                          className="row"
                                          style={{ marginBottom: 40 }}
                                        >
                                          <div className="col-12">
                                            <button
                                              type="button"
                                              onClick={() => {
                                                this.state.specifyVehicle
                                                  ? this.handleUnSpecifyChange(
                                                      "specifyVehicle"
                                                    )
                                                  : this.handleChange(
                                                      "specifyVehicle"
                                                    );
                                              }}
                                              className={
                                                this.state.specifyVehicle
                                                  ? "btn btn-black display-4 specifybutton"
                                                  : "btn btn-success display-4 specifybutton"
                                              }
                                            >
                                              {this.state.specifyVehicle ? (
                                                <span>
                                                  Select
                                                  <br />
                                                  All Vehicles
                                                </span>
                                              ) : (
                                                <span>
                                                  Specify
                                                  <br />
                                                  Vehicles
                                                </span>
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                        {this.state.specifyVehicle &&
                                          this.state.carmodels.length > 0 && (
                                            <div className="col-lg-12 form-group timeslotfield">
                                              <label
                                                for="timeslotfield"
                                                className="form-control-label mbr-fonts-style display-7"
                                              >
                                                Select Vehicle Types
                                              </label>
                                              <Select
                                                mode="multiple"
                                                showArrow
                                                tagRender={this.tagRender}
                                                style={{ width: "100%" }}
                                                onChange={(selectedvalue) => {
                                                  if (
                                                    selectedvalue.length > 0
                                                  ) {
                                                    this.setState({
                                                      vehicle_types:
                                                        getidfromkey(
                                                          selectedvalue
                                                        ),
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                  // else if (
                                                  //   this.state.time_slots
                                                  //     .length === 0 &&
                                                  //   this.state.dest_inations
                                                  //     .length === 0
                                                  // ) {
                                                  //   this.setState({
                                                  //     vehicle_types: [],
                                                  //     formchange: true,
                                                  //     specifyStartDate: true,
                                                  //   });
                                                  // }
                                                  else {
                                                    this.setState({
                                                      vehicle_types: [],
                                                      formchange: true,
                                                      specifyStartDate: false,
                                                    });
                                                  }
                                                }}
                                              >
                                                {this.state.carmodels}
                                              </Select>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 col-md-12 form-group ">
                                    <div className="justify-content-center row">
                                      <div className="row col-12 col-lg-5 budgetinput">
                                        <div className="col-12">
                                          <label
                                            for="budgetfield"
                                            className="form-control-label mbr-fonts-style display-5"
                                          >
                                            Enter Your Budget*
                                          </label>
                                        </div>
                                        <div className="col-12">
                                          <Input
                                            addonBefore="ETB"
                                            type="text"
                                            min="0"
                                            name="budget"
                                            required
                                            data-form-field="budget"
                                            id="budgetfield"
                                            onChange={(val) => {
                                              this.setState({
                                                budget: val.target.value,
                                                formchange: true,
                                              });
                                              if (
                                                this.state.budgetError !== ""
                                              ) {
                                                const tempbudgetError =
                                                  adbudgetValidation(
                                                    val.target.value,
                                                    5000,
                                                    this.state.selectedRegionObj
                                                      .minimumBudget
                                                  );
                                                this.setState({
                                                  budgetError: tempbudgetError,
                                                });
                                              }
                                            }}
                                            value={this.state.budget}
                                          />
                                          <small className="errorHint">
                                            <i className="formerror fa fa-asterisk"></i>
                                            <p className="errorRed">
                                              {this.state.budgetError}
                                            </p>
                                          </small>
                                          {/* <input /> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 col-md-12 form-group ">
                                    <div className="justify-content-center row">
                                      <div className="row col-lg-3 col-md-4 col-sm-8">
                                        <div className="col-12">
                                          <label
                                            for="frequencyperroutefield"
                                            className="form-control-label mbr-fonts-style display-5 frequencyperroutelabel"
                                          >
                                            Frequency Per Route*
                                          </label>
                                        </div>
                                        <div className="col-12">
                                          <input
                                            type="number"
                                            maxLength="1"
                                            min={
                                              this.state.selectedRegionObj
                                                .minimumFreqPerRoute
                                            }
                                            max={
                                              this.state.selectedRegionObj
                                                .maximumFreqPerRoute
                                            }
                                            name="frequencyperroute"
                                            required
                                            data-form-field="frequencyperroute"
                                            className="form-control"
                                            id="frequencyperroutefield"
                                            onChange={(val) => {
                                              this.setState({
                                                frequency_per_route:
                                                  val.target.value,
                                                formchange: true,
                                              });
                                              if (
                                                this.state.frequencyError !== ""
                                              ) {
                                                const tempfreqError =
                                                  adfrequencyValidation(
                                                    val.target.value,
                                                    this.state.selectedRegionObj
                                                      .maximumFreqPerRoute,
                                                    this.state.selectedRegionObj
                                                      .minimumFreqPerRoute
                                                  );
                                                this.setState({
                                                  frequencyError: tempfreqError,
                                                });
                                              }
                                            }}
                                            value={
                                              this.state.frequency_per_route
                                            }
                                          />
                                          <small className="errorHint">
                                            <i className="formerror fa fa-asterisk"></i>
                                            <p className="errorRed">
                                              {this.state.frequencyError}
                                            </p>
                                          </small>
                                        </div>
                                        <div className="col-12">
                                          <label
                                            for="frequencyperroutefield"
                                            className="form-control-label mbr-fonts-style display-5 frequencyperroutelabel"
                                          >
                                            The larger the frequency per route,
                                            the faster your advertisement will
                                            be served
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-12"
                                    style={{
                                      display:
                                        this.state.selectedRegion === null
                                          ? "none"
                                          : "inline",
                                      textAlign: "center",
                                    }}
                                  >
                                    <div className="justify-content-center row">
                                      <div className="justify-content-center col-lg-5 col-12 form-group">
                                        <label
                                          for="startdatefield"
                                          className="form-control-label mbr-fonts-style display-7"
                                        >
                                          Start Date*
                                        </label>
                                        <br />
                                        {this.state.startDateLoading ? (
                                          <div
                                            className="row justify-content-center"
                                            style={{ marginBottom: 40 }}
                                          >
                                            <h2 className="mbr-section-title mb-4 mbr-fonts-style align-center display-5">
                                              {" "}
                                              <strong>Loading</strong>
                                              <br />
                                              <div className="lds-ellipsis lds-ellipsis">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                              </div>
                                            </h2>
                                          </div>
                                        ) : !this.state.specifyStartDate ? (
                                          <div className="col-12">
                                            <p className="mbr-section-title mbr-fonts-style mb-0 display-7">
                                              {this.state.start_date !== null
                                                ? this.state.start_date.toDateString()
                                                : ""}
                                            </p>
                                            <button
                                              type="button"
                                              onClick={() => {
                                                this.setState({
                                                  startDateLoading: true,
                                                });
                                                setTimeout(
                                                  function () {
                                                    //Start the timer
                                                    this.onSpecifyStartDate();
                                                  }.bind(this),
                                                  500
                                                );
                                              }}
                                              style={{ margin: "auto" }}
                                              className="btn btn-success display-4"
                                            >
                                              Change Starting Date
                                            </button>
                                          </div>
                                        ) : (
                                          <DayPicker
                                            initialMonth={new Date()}
                                            showOutsideDays
                                            selectedDays={this.state.start_date}
                                            modifiers={{
                                              risky:
                                                this.state.dest_inations
                                                  .length === 0 &&
                                                this.state.time_slots.length ===
                                                  0 &&
                                                this.state.vehicle_types
                                                  .length === 0
                                                  ? this.state
                                                      .o_overThreeFourthOccupied
                                                  : this.state
                                                      .overThreeFourthOccupied,
                                              done:
                                                this.state.dest_inations
                                                  .length === 0 &&
                                                this.state.time_slots.length ===
                                                  0 &&
                                                this.state.vehicle_types
                                                  .length === 0
                                                  ? this.state.o_fullOccupied
                                                  : this.state.fullOccupied,
                                            }}
                                            modifiersStyles={
                                              this.modifiersStyles
                                            }
                                            onDayClick={(day) => {
                                              if (
                                                this.state.selectedRegionObj !==
                                                null
                                              ) {
                                                if (
                                                  day >=
                                                    new Date(
                                                      new Date().setDate(
                                                        this.state.static_start_date.getDate() -
                                                          1
                                                      )
                                                    ) &&
                                                  day <
                                                    new Date().setDate(
                                                      this.state.static_start_date.getDate() +
                                                        this.state
                                                          .selectedRegionObj
                                                          .scheduleRestriction -
                                                        1
                                                    )
                                                ) {
                                                  this.setState({
                                                    start_date: day,
                                                    formchange: true,
                                                  });
                                                  if (
                                                    this.state.end_date !==
                                                      "" &&
                                                    day > this.state.end_date
                                                  ) {
                                                    this.setState({
                                                      end_date: day,
                                                      formchange: true,
                                                    });
                                                  }
                                                }
                                              }
                                            }}
                                            disabledDays={
                                              this.state.selectedRegionObj !==
                                              null
                                                ? {
                                                    ...this.state
                                                      .disabledstartingdays,
                                                    before:
                                                      this.state
                                                        .static_start_date,
                                                    after: new Date(
                                                      new Date().setDate(
                                                        this.state.static_start_date.getDate() +
                                                          this.state
                                                            .selectedRegionObj
                                                            .scheduleRestriction -
                                                          1
                                                      )
                                                    ),
                                                  }
                                                : {}
                                            }
                                          />
                                        )}
                                        <br />

                                        {this.state.dest_inations.length ===
                                          0 &&
                                        this.state.time_slots.length === 0 &&
                                        this.state.vehicle_types.length === 0
                                          ? this.state.o_overThreeFourthOccupied
                                              .length > 0 && (
                                              <p
                                                className="display-9"
                                                style={{ color: "#FFC35C" }}
                                              >
                                                {" "}
                                                The Dates in Yellow are already
                                                75% Occupied.{" "}
                                              </p>
                                            )
                                          : this.state.overThreeFourthOccupied
                                              .length > 0 && (
                                              <p
                                                className="display-9"
                                                style={{ color: "#FFC35C" }}
                                              >
                                                {" "}
                                                The Dates in Yellow are already
                                                75% Occupied.{" "}
                                              </p>
                                            )}
                                        {this.state.dest_inations.length ===
                                          0 &&
                                        this.state.time_slots.length === 0 &&
                                        this.state.vehicle_types.length === 0
                                          ? this.state.o_fullOccupied.length >
                                              0 && (
                                              <p
                                                className="display-9"
                                                style={{ color: "#FF0000" }}
                                              >
                                                {" "}
                                                The Dates in Red are already
                                                100% Occupied.{" "}
                                              </p>
                                            )
                                          : this.state.fullOccupied.length >
                                              0 && (
                                              <p
                                                className="display-9"
                                                style={{ color: "#FF0000" }}
                                              >
                                                {" "}
                                                The Dates in Red are already
                                                100% Occupied.{" "}
                                              </p>
                                            )}
                                      </div>

                                      <div className="justify-content-center col-lg-2 col-12 form-group">
                                        <div
                                          style={{
                                            display:
                                              this.state.onProgress ||
                                              this.state.formchange
                                                ? "none"
                                                : "block",
                                          }}
                                        >
                                          {this.state.timestatus === 2 ? (
                                            <p className="mbr-section-title mbr-fonts-style mb-0">
                                              <p className="display-9">
                                                Status
                                              </p>
                                              <br />

                                              <strong>
                                                <img
                                                  src={notime}
                                                  className="timeicon"
                                                  alt=""
                                                  title=""
                                                />
                                              </strong>
                                            </p>
                                          ) : this.state.timestatus === 1 ? (
                                            <p className="mbr-section-title mbr-fonts-style mb-0">
                                              <p className="display-9">
                                                Status
                                              </p>
                                              <br />

                                              <strong>
                                                <img
                                                  src={ontime}
                                                  className="timeicon"
                                                  alt=""
                                                  title=""
                                                />
                                              </strong>
                                            </p>
                                          ) : (
                                            <br />
                                          )}
                                        </div>
                                      </div>

                                      <div className="row justify-content-center col-lg-5 col-12 form-group">
                                        <div
                                          className="col-12"
                                          style={{
                                            // display: this.state.onProgress
                                            //   ? "none"
                                            //   : "block",
                                            textAlign: "center",
                                          }}
                                        >
                                          <label
                                            for="enddatefield"
                                            className="form-control-label mbr-fonts-style display-7"
                                          >
                                            Expire Date (Optional)
                                          </label>
                                          <br />
                                          <div className="col-12">
                                            <button
                                              type="button"
                                              onClick={() => {
                                                this.handleChange(
                                                  "specifyEndDate"
                                                );
                                              }}
                                              style={{ margin: "auto" }}
                                              className="btn btn-success display-4"
                                            >
                                              {this.state.specifyEndDate
                                                ? "Unspecify Expire Date"
                                                : "Specify Expire Date"}
                                            </button>
                                          </div>
                                          {this.state.specifyEndDate &&
                                            this.state.selectedRegionObj !==
                                              null && (
                                              <DayPicker
                                                initialMonth={new Date()}
                                                showOutsideDays
                                                selectedDays={
                                                  this.state.end_date
                                                }
                                                onDayClick={(day) => {
                                                  if (
                                                    day <
                                                    new Date().setDate(
                                                      this.state.static_start_date.getDate() +
                                                        this.state
                                                          .selectedRegionObj
                                                          .roughEstimate -
                                                        1
                                                    )
                                                  ) {
                                                    this.setState({
                                                      end_date: day,
                                                      formchange: true,
                                                    });
                                                  } else {
                                                    console.log("elsee");
                                                    console.log(
                                                      new Date(
                                                        new Date().setDate(
                                                          this.state.static_start_date.getDate() +
                                                            this.state
                                                              .selectedRegionObj
                                                              .roughEstimate -
                                                            1
                                                        )
                                                      )
                                                    );
                                                    this.setState({
                                                      end_date: new Date(
                                                        new Date().setDate(
                                                          this.state.static_start_date.getDate() +
                                                            this.state
                                                              .selectedRegionObj
                                                              .roughEstimate -
                                                            1
                                                        )
                                                      ),
                                                      formchange: true,
                                                    });
                                                  }
                                                }}
                                                disabledDays={[
                                                  {
                                                    before:
                                                      this.state.start_date,
                                                    after: new Date(
                                                      new Date().setDate(
                                                        this.state.static_start_date.getDate() +
                                                          this.state
                                                            .selectedRegionObj
                                                            .roughEstimate -
                                                          1
                                                      )
                                                    ),
                                                  },
                                                ]}
                                              />
                                            )}
                                          {!this.state.formchange &&
                                          this.state.timestatus === 2 ? (
                                            <p
                                              className="display-7"
                                              style={{ color: "red" }}
                                            >
                                              <strong>
                                                {" "}
                                                Your AD might not finish by this
                                                date
                                              </strong>
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row justify-content-center col-12">
                                    <div
                                      className="col-lg-6 col-md-6 col-sm-6 align-center mbr-section-btn"
                                      id="client_register_form_register_btn_div"
                                    >
                                      {this.state
                                        .showloadingwhilecalculating ? (
                                        <div
                                          className="row justify-content-center"
                                          style={{ marginBottom: 40 }}
                                        >
                                          <h2 className="mbr-section-title mb-4 mbr-fonts-style align-center display-2">
                                            {" "}
                                            <strong>Calculating</strong>
                                            <br />
                                            <div className="lds-ellipsis lds-ellipsis">
                                              <div></div>
                                              <div></div>
                                              <div></div>
                                              <div></div>
                                            </div>
                                          </h2>
                                        </div>
                                      ) : (
                                        <button
                                          style={{ marginBottom: "2rem" }}
                                          onClick={() => {
                                            var anyerror = false;
                                            if (
                                              this.state.calculated_length <= 0
                                            ) {
                                              anyerror = true;
                                            }
                                            const tempadtitleError =
                                              adtitleValidation(
                                                this.state.ad_title
                                              );
                                            if (tempadtitleError !== "") {
                                              anyerror = true;
                                              this.setState({
                                                adtitleError: tempadtitleError,
                                              });
                                            }

                                            const tempadbudgetError =
                                              adbudgetValidation(
                                                this.state.budget,
                                                5000000,
                                                this.state.selectedRegionObj
                                                  .minimumBudget
                                              );
                                            if (tempadbudgetError !== "") {
                                              anyerror = true;
                                              this.setState({
                                                budgetError: tempadbudgetError,
                                              });
                                            }
                                            const tempfreqError =
                                              adfrequencyValidation(
                                                this.state.frequency_per_route,
                                                this.state.selectedRegionObj
                                                  .maximumFreqPerRoute,
                                                this.state.selectedRegionObj
                                                  .minimumFreqPerRoute
                                              );
                                            if (tempfreqError !== "") {
                                              anyerror = true;
                                              this.setState({
                                                frequencyError: tempfreqError,
                                              });
                                            }

                                            if (!anyerror) {
                                              this.setState({
                                                showloadingwhilecalculating: true,
                                              });
                                            } else {
                                              toast.error(
                                                "You have some errors on your inputs.\nPlease follow and apply the corrections."
                                              );
                                            }
                                          }}
                                          className="btn btn-success display-4"
                                        >
                                          Calculate Serving Amount
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <section
                                className="info2 cid-sFK1iWKGeH"
                                id="info2-2c"
                                style={{
                                  display: this.state.onProgress
                                    ? "none"
                                    : "block",
                                }}
                              >
                                <div className="align-center container-fluid">
                                  <div className="row justify-content-center">
                                    <div className="row justify-content-center">
                                      <div className="col-12 col-lg-12">
                                        <div className="wrapper">
                                          <h3 className="mbr-text mb-4 mbr-fonts-style display-7">
                                            <strong>
                                              Calculated AD Serving Duration in
                                              days
                                            </strong>
                                          </h3>
                                          <h3 className="mbr-section-title mb-4 mbr-fonts-style display-3">
                                            <strong id="approxamountx">
                                              {this.state.duration}
                                            </strong>
                                            {/* <span className="adservex">x</span>*/}
                                          </h3>
                                          {!this.state.formchange &&
                                          this.state.timestatus === 2 ? (
                                            <p
                                              className="display-7"
                                              style={{ color: "red" }}
                                            >
                                              <strong>
                                                {" "}
                                                Your AD might not finish by this
                                                date
                                              </strong>
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          <br />
                                          <br />
                                          <br />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-12">
                                      <h3 className="mbr-section-title mb-4 mbr-fonts-style display-5">
                                        <strong>
                                          Your Range of AD Playing Amount
                                        </strong>
                                      </h3>
                                    </div>
                                    <div className="row justify-content-center">
                                      <div className="col-12 col-lg-12">
                                        <div className="wrapper">
                                          <h3 className="mbr-text mb-4 mbr-fonts-style display-5">
                                            Predicted Serving Amount
                                          </h3>
                                          <h3 className="mbr-section-title mb-4 mbr-fonts-style display-3">
                                            <strong id="approxamountx">
                                              {this.state.preserveamount}
                                            </strong>
                                            {/* <span className="adservex">x</span>*/}
                                          </h3>
                                          <p className="mbr-text mb-4 mbr-fonts-style display-4">
                                            This is the predicted number that
                                            your advertisement plays. This is
                                            computed by our algorithm and may
                                            not be the exactly accurate.
                                            <a
                                              href="http://google.com"
                                              className="text-black"
                                              rel="noreferrer"
                                              target="_blank"
                                            >
                                              Read More
                                            </a>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {this.state.selectedRegionObj !== null &&
                                      this.state.duration <
                                        this.state.selectedRegionObj
                                          .roughEstimate &&
                                      this.state.minserveamount <=
                                        this.state.preserveamount && (
                                        <div className="card col-12 col-lg-6">
                                          <div className="wrapper">
                                            <p className="mbr-text mb-4 mbr-fonts-style display-5">
                                              Minimum Serving Amount
                                            </p>
                                            <h3 className="mbr-section-title mb-4 mbr-fonts-style display-3">
                                              <strong id="minamountx">
                                                {this.state.minserveamount}
                                              </strong>
                                              {/* <span className="adservex">x</span>*/}
                                            </h3>
                                            <p className="mbr-text mb-4 mbr-fonts-style display-4">
                                              This is the minimum number that
                                              your advertisement plays. This is
                                              number is calculated by
                                              considering potentially the most
                                              expensive setup.
                                              <a
                                                href="http://google.com"
                                                className="text-black"
                                                rel="noreferrer"
                                                target="_blank"
                                              >
                                                Read More
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    {this.state.selectedRegionObj !== null &&
                                      this.state.duration <
                                        this.state.selectedRegionObj
                                          .roughEstimate &&
                                      this.state.minserveamount <=
                                        this.state.preserveamount && (
                                        <div className="col-12 col-lg-6">
                                          <div className="wrapper">
                                            <p className="mbr-text mb-4 mbr-fonts-style display-5">
                                              Maximum Serving Amount
                                            </p>
                                            <h3 className="mbr-section-title mbr-fonts-style mb-4 display-3">
                                              <strong id="maxamountx">
                                                {this.state.maxserveamount}
                                              </strong>
                                              {/* <span className="adservex">x</span>*/}
                                            </h3>
                                            <p className="mbr-text mbr-fonts-style mb-4 display-4">
                                              This is the maximum number that
                                              your advertisement plays. This is
                                              number is calculated by
                                              considering potentially the
                                              cheapest setup.
                                              <a
                                                href="http://google.com"
                                                className="text-black"
                                                rel="noreferrer"
                                                target="_blank"
                                              >
                                                Read More
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </section>
                              <div
                                className="row"
                                style={{
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="col align-center mbr-section-btn"
                                  id="client_register_form_register_btn_div"
                                >
                                  <button
                                    type="button"
                                    className="btn btn-white display-4"
                                    onClick={() => {
                                      this.showModal();
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                                <div
                                  className="col align-center mbr-section-btn"
                                  id="client_register_form_register_btn_div"
                                >
                                  <button
                                    type="button"
                                    onClick={this.onClear}
                                    className="btn btn-success display-4"
                                  >
                                    Clear
                                  </button>
                                </div>
                                <div
                                  className="col align-center mbr-section-btn"
                                  id="client_register_form_register_btn_div"
                                  style={{
                                    display: this.state.onProgress
                                      ? "none"
                                      : "block",
                                  }}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-black display-4"
                                    onClick={() => {
                                      if (this.state.formchange) {
                                        this.setState({
                                          formchangesubmit: true,
                                        });
                                      } else {
                                        this.setState({
                                          submittest: true,
                                        });
                                      }
                                    }}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : this.props.region.adscheduleloading ||
                            this.props.region.destinationsloading ||
                            this.props.region.timeslotsloading ||
                            this.props.region.carmodelsloading ||
                            this.props.region.routeaverageloading ? (
                            <div className="col-lg-12">
                              <div
                                className="row justify-content-center"
                                style={{ marginBottom: 40 }}
                              >
                                <h2 className="align-center display-2">
                                  {" "}
                                  <strong>Loading</strong>
                                  <br />
                                  <div className="lds-ellipsis ">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                  </div>
                                </h2>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <h3 className="mbr-section-title mb-4 mbr-fonts-style display-2">
                                <strong className="display-5">
                                  Sorry, the region is not available for testing{" "}
                                  <br />
                                  <br />
                                </strong>
                                <strong>
                                  Please Choose Another Region or Try Again
                                  Later
                                </strong>
                              </h3>
                            </div>
                          )}
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Modal
            title="Are You Sure"
            visible={this.state.areyousureModal}
            onCancel={this.handleCancelSure}
            footer={[
              <Button
                className="btn btn-white display-5"
                key="back"
                onClick={this.handleCancel}
              >
                Not Now
              </Button>,
              <Button
                key="submit"
                className="btn btn-black display-5"
                onClick={this.handleOk}
              >
                Register and Buy Airtime
              </Button>,
            ]}
          >
            <p>Are You Sure You Want to Cancel the Demo?</p>
          </Modal>
          <Modal
            title="Restricted"
            visible={this.state.formchangesubmit}
            onOk={this.handleCancelSure}
            onCancel={this.handleCancelSure}
            footer={[
              <Button
                key="submit"
                className="btn btn-primary display-5"
                onClick={this.handleCancelSure}
              >
                OK
              </Button>,
            ]}
          >
            <Title level={4}>
              Please Press "Calculate Serving Amount" Button before Submitting
            </Title>
          </Modal>
          <Modal
            className="testmodal"
            visible={this.state.submittest}
            title="Spread Your Word!"
            onOk={this.handleOk}
            onCancel={() => {
              this.handleCancel();
              window.location = "/";
            }}
            footer={[
              <Button
                className="btn btn-white display-4"
                key="back"
                onClick={() => {
                  this.handleCancel();
                  this.props.deleteAnonUser();
                  window.location = "/";
                }}
              >
                Not Now
              </Button>,
              <Button
                key="submit"
                className="btn btn-black display-4"
                onClick={this.handleOk}
              >
                Register and Buy Airtime
              </Button>,
            ]}
          >
            <p className="display-4">
              Negarit made the process of putting your business on the map and
              spreading your word easy, cheap, and flexible.
              <br /> Create an Account Now and Start Right Away
            </p>
          </Modal>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    region: state.region,
    firestore: state.firestore,
    airtime: state.airtime,
    adcard: state.adcard,
    // timeslots: state.firestore.ordered.timeSlot,
    // carmodels: state.firestore.ordered.carModel,
    // superpath: state.firestore.ordered.superPath
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getController: (region) => dispatch(GetController(region)),
    getTimeSlots: (region) => dispatch(GetTimeSlotsTest(region)),
    getDestinations: (region) => dispatch(GetDestinationsTest(region)),
    getCarModels: (region) => dispatch(GetCarModelsTest(region)),
    getRegions: () => dispatch(GetRegionsForBusiness()),
    getAdSchedules: (id, extraStartDays, roughEstimate) =>
      dispatch(GetAdSchedules(id, extraStartDays, roughEstimate)),
    getRouteAverages: (id) => dispatch(GetRouteAverages(id)),
    signInAnonymously: () => dispatch(signInAnonymously()),
    deleteAnonUser: () => dispatch(deleteAnonUser()),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  BusinessTestBuyComponent
);
